// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".receipt-page__head-content[data-v-16cb0507]{width:100%}@media (min-width:1024px){.receipt-page__head-content[data-v-16cb0507]{margin-left:auto;margin-right:auto;max-width:46rem}}@media (min-width:1280px){.receipt-page__head-content[data-v-16cb0507]{margin-left:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
